module.exports = __webpack_public_path__ + "static/media/TymeBankCard.1623b8f0.svg";